export default (category?: string | null) =>
  category
    ?.replace(/-/g, ' ')
    ?.split(/\s+/)
    .map((c) => c.charAt(0).toUpperCase() + c.slice(1).toLowerCase())
    .join(' ') || '';
